import { createFileRoute } from "@tanstack/react-router";
import AdminFeedImport from "@/pages/admin/AdminFeedImport";

export const Route = createFileRoute("/_adminLayout/admin/feed-import")({
  component: AdminFeedImport,
});
